import { all }                       from 'redux-saga/effects';
import { processApiRequests }        from './resources/processRequestActions';
import { autoloadShortlistServices } from './resources/autoloadShortlistServices';
import handleApiDeleteRequests  from './resources/handleApiDeleteRequests';
import handleApiFetchRequests  from './resources/handleApiFetchRequests';
import handleApiSaveRequests  from './resources/handleApiSaveRequests';


export function* resourceSagas() {

  yield all([
    handleApiFetchRequests(),
    handleApiSaveRequests(),
    handleApiDeleteRequests(),
    processApiRequests(),
    autoloadShortlistServices(),
  ]);

}


// WEBPACK FOOTER //
// ./src/sagas/resourceSagas.js